export default __webpack_public_path__ + "static/media/By Alana Coghlan.20ae5342.jpg";